
import { onMounted, ref } from 'vue';
import { isEmpty } from 'lodash';
import { useStoreInNodes } from '@/composables/useStoreInNodes';
import { onClickOutside } from '~/directives/onClickOutside';
import { GetPluginById } from '@/constants/actions';
import FormGenerator from '@/components/common/FormGenerator';

export default {
  components: { FormGenerator },

  directives: {
    'click-outside': onClickOutside,
  },

  props: {
    onClose: { type: Function, default: () => {} },
    onCancel: { type: Function, default: () => {} },
    onSave: { type: Function, default: () => {} },
    fields: { type: Object, default: () => ({}) },
    pluginId: { type: String, default: '' },
  },

  setup(props) {
    const { store } = useStoreInNodes();

    const changes = ref([]);
    const changesToSave = ref({});
    const loadingSettings = ref(true);
    const hasError = ref(false);
    const hasChange = ref(false);

    onMounted(async () => {
      const { settings } = (await store.value.dispatch(`pluginStore/${GetPluginById}`, props.pluginId)) || {};
      loadingSettings.value = false;

      changes.value = settings.map((setting) => {
        const value = props.fields?.[setting.id];

        return {
          ...setting,
          value: setting.type === 'boolean' ? !!value : value,
          label: setting.label || setting.id,
        };
      });
    });

    const onDataChange = (values) => {
      changesToSave.value = values.data;
      hasError.value = values.hasError;
      hasChange.value = values.hasChange;
    };

    const saveData = () => {
      if (hasError.value || !hasChange.value || isEmpty(changesToSave.value)) {
        return;
      }

      props.onSave({ settings: changesToSave.value });
    };

    return {
      changes,
      hasChange,
      hasError,
      loadingSettings,
      onDataChange,
      saveData,
    };
  },
};
